// extracted by extract-css-chunks-webpack-plugin
module.exports = {"LTOBanner":"_2uJomD","ribbon":"_2Kl3OP","absolutePos":"_3XAxll","text":"_3LKGuW"};